<div class="w-full flex flex-wrap">
    <app-user-activity-info [User]="Post | getUserData:false" [inside]="true" [displayDate]="false" [size]="'small'">
    </app-user-activity-info>

    <!-- ? Post image -->
    <div class="w-full mt-2">
        <a [routerLink]="[routes.post, Post.id]">
            @if(Post.mediaExtension === 3){
            <img class="w-full rounded-md aspect-[2/1] object-cover"
                [src]="Post.mediaId! | image : imageType.videoThumbnail : true" [alt]="Post?.title"
                onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_broken.svg'" />
            }@else{
            <img [src]="Post.mediaId! | image:imageType.post:Post?.hasPhoto" class="rounded-lg ratio-2-1 object-cover"
                [alt]="Post?.title"
                onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_broken.svg'">
            }
        </a>
    </div>
</div>